import { useContext } from "react";
import { GlobalLoadingContext } from "../context";

export const useGlobalLoading = () => {
  const { isGloballyLoading } = useContext(GlobalLoadingContext);
  return { isGloballyLoading };
};
